<template>
    <div class="wrap">
        <div class="calendar_table" :class="{ 'feastday': day.dateInfo.isFeastDay && day.inCurrentMonth, 'sabbath': day.dateInfo.isSabbath && day.inCurrentMonth, 'lightday': !day.inCurrentMonth}">
            <div class="calendar_row">
                <div :class="{ 'inmonth': day.inCurrentMonth, 'outmonth': !day.inCurrentMonth}" class="cell left inmonth">
                    <div v-if="!this.$parent.$parent.editableDays" class="inlineflex">{{day.day}}</div>
                    <div v-if="this.$parent.$parent.editableDays" class="cursor-pointer inlineflex" @click="this.showEditDayPopup(day)">{{day.day}}</div>                    
                    <i v-if="this.zadocDateCompare(day, currentDate)" class="left-icons far fa-calendar-alt fa-m todayText">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Current Selected Day<br>Default :Today (UTC time)</q-tooltip>
                    </i>
                    <i v-if="this.isEquinox(day)" class="left-icons fal fa-sun fa-m redText">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Equinox</q-tooltip>
                    </i>
                    <i v-if="this.dayOfRemembrance(day)" class="left-icons fal fa-award fa-m blueText">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Day of Remembrance</q-tooltip>
                    </i>                    
                </div>
                <div class="cell right">
                    <i @click="this.showModalPopup(day)" :class="{ 'cursor-pointer right-icons fal fa-info-square fa-lg' :day.dateInfo.isInformation}">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Information</q-tooltip>
                    </i>
                    <i @click="this.showModalPopup(day)" :class="{ 'cursor-pointer right-icons fal fa-menorah fa-lg' :day.dateInfo.isFeastDay}">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Feast Day</q-tooltip>
                    </i>
                    <i :class="{ 'right-icons fal fa-pray fa-lg' :day.dateInfo.isSabbath}">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Sabbath Day</q-tooltip>
                    </i>
                </div>            
            </div>
            <div class="calendar_row_middle">
                <div v-if="day.dateInfo.feastDay.length > 0" v-html="day.dateInfo.feastDay" class="cell full" style="font-size: smaller"></div>
                <div v-if="day.dateInfo.feastDay.length == 0" class="cell full" style="font-size: x-small">&nbsp;</div>
                <!-- <div @click="this.$parent.$parent.showModalPopup(day)" class="cell"><i :class="{ 'fal fa-info-square fa-lg' :day.dateInfo.feastDay.length > 0}"></i></div>                 -->
            </div>
            
            <div class="calendar_row_bottom">
                <div style="font-size: x-small;" class="cell left">{{formatDate(day.gregorianDate)}}&nbsp;</div>        
                <!-- <div class="cell right"></div>                 -->
                <div style="overflow:hidden;" class="cell right">
                    <i v-if="isFullMoon(day)" style="overflow:hidden;" class="right-icons fal fa-moon fa-s">
                        <q-tooltip transition-show="flip-right" transition-hide="flip-left">Full Moon</q-tooltip>
                    </i>&nbsp;
                </div>
                
                <!-- <div v-if="moonphase" style="overflow:hidden;" class="cell right" v-html="'<svg width=\'10\' height=\'10\' viewBox=\'0 0 100 100\'><g><circle cx=\'50\' cy=\'50\' r=\'49\' stroke=\'none\'  fill=\'\'black\'\'\/><path d=\'M 50 1 A 49,49 0 0,1 49,99 A 21.56,49 0 1,0 50,1\' stroke-width=\'0\' stroke=\'none\' fill=\'#FFFF88\' \/><a xlink:href=\'https:\/\/www.icalendar37.net\/lunar\/app\/\' rel=\'noopener noreferrer\' target=\'_blank\'><circle cx=\'50\' cy=\'50\' r=\'49\' style=\'pointer-events:all;cursor:pointer\' stroke-width=\'0\'   fill=\'transparent\' \/><\/a><\/g><\/svg>'"></div>                 -->
            </div>            
        </div>
    </div>

    <template>
         <div class="q-pa-md q-gutter-sm my-card">
            <q-dialog v-model="showModal">
                <q-card :class="{ 'my-card' :day.dateInfo.showInWideBox}">
                    <q-toolbar>
                        <q-avatar rounded size="48px">
                            <i class="fal fa-info-square fa-2x"></i>
                        </q-avatar>

                        <q-toolbar-title v-html="'<span class=\'text-weight-bold\'>' + this.dayInfo.dateInfo.feastDay"></q-toolbar-title>
                        <q-badge class="right-icons" v-if="this.dayInfo.dateInfo.isSabbath" color="orange" label="Sabbath" />
                        <q-badge class="right-icons" v-if="this.dayInfo.dateInfo.isFeastDay" color="primary" label="Feast" />
                        <q-badge class="right-icons" v-if="this.dayInfo.dateInfo.isInformation" color="secondary" label="Information" />

                        <q-btn flat dense icon="close" v-close-popup />
                    </q-toolbar>

                    <q-card-section v-html="this.dayInfo.dateInfo.description">
                    
                    </q-card-section>
                </q-card>
            </q-dialog>
        </div>
    </template>

    <template>
        <q-dialog v-model="showEditDay" persistent>
            <q-card class="my-card">
                <q-card-section>
                    <q-form @submit="onSubmit(dayInfo2)" @reset="onReset" class="q-gutter-md">
                        <q-badge v-if="!dayInfo2.dateInfo.isSabbath" outline color="orange" label="Sabbath" />
                        <q-badge v-if="dayInfo2.dateInfo.isSabbath" color="orange" label="Sabbath" />
                        <q-toggle v-model="dayInfo2.dateInfo.isSabbath" color="orange"/>
                        <q-badge v-if="!dayInfo2.dateInfo.isFeastDay" outline color="primary" label="Feast" />
                        <q-badge v-if="dayInfo2.dateInfo.isFeastDay" color="primary" label="Feast" />
                        <q-toggle v-model="dayInfo2.dateInfo.isFeastDay" color="blue"/>
                        <q-badge v-if="!dayInfo2.dateInfo.isInformation" outline color="secondary" label="Information" />
                        <q-badge v-if="dayInfo2.dateInfo.isInformation" color="secondary" label="Information" />                        
                        <q-toggle v-model="dayInfo2.dateInfo.isInformation" color="secondary"/>
                        <q-badge v-if="!dayInfo2.dateInfo.showInWideBox" outline color="purple" label="Show in Wide Display Box" />
                        <q-badge v-if="dayInfo2.dateInfo.showInWideBox" color="purple" label="Show in Wide Display Box" />        
                        <q-toggle v-model="dayInfo2.dateInfo.showInWideBox" color="purple"/>

                        <q-input v-if="dayInfo2.dateInfo.isFeastDay || dayInfo2.dateInfo.isSabbath || dayInfo2.dateInfo.isInformation" filled v-model="dayInfo2.dateInfo.feastDay" label="Day Display" hint="Text to display on the calendar"/>

                        <q-separator />
                        <q-banner v-if="dayInfo2.dateInfo.isFeastDay || dayInfo2.dateInfo.isInformation" inline-actions dense rounded class="bg-orange text-white">Description to be displayed on the Popup Screen</q-banner>

                        <q-editor ref="editorRef" v-if="dayInfo2.dateInfo.isFeastDay || dayInfo2.dateInfo.isInformation" v-model="dayInfo2.dateInfo.description" 
                            min-height="5rem"                                                    
                                :toolbar="[
                                    [                                    
                                    {
                                        label: $q.lang.editor.align,
                                        icon: $q.iconSet.editor.align,
                                        fixedLabel: true,
                                        options: ['left', 'center', 'right', 'justify']
                                    }
                                    ],
                                    ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                                    ['token', 'hr', 'link', 'custom_btn'],
                                    ['print', 'fullscreen'],
                                    [
                                    {
                                        label: $q.lang.editor.formatting,
                                        icon: $q.iconSet.editor.formatting,
                                        list: 'no-icons',
                                        options: [
                                        'p',
                                        'h1',
                                        'h2',
                                        'h3',
                                        'h4',
                                        'h5',
                                        'h6',
                                        'code'
                                        ]
                                    },
                                    {
                                        label: $q.lang.editor.fontSize,
                                        icon: $q.iconSet.editor.fontSize,
                                        fixedLabel: true,
                                        fixedIcon: true,
                                        list: 'no-icons',
                                        options: [
                                        'size-1',
                                        'size-2',
                                        'size-3',
                                        'size-4',
                                        'size-5',
                                        'size-6',
                                        'size-7'
                                        ]
                                    },
                                    {
                                        label: $q.lang.editor.defaultFont,
                                        icon: $q.iconSet.editor.font,
                                        fixedIcon: true,
                                        list: 'no-icons',
                                        options: [
                                        'default_font',
                                        'arial',
                                        'arial_black',
                                        'comic_sans',
                                        'courier_new',
                                        'impact',
                                        'lucida_grande',
                                        'times_new_roman',
                                        'verdana'
                                        ]
                                    },
                                    'removeFormat'
                                    ],
                                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                                    ['undo', 'redo'],
                                    ['viewsource']
                                ]"
                                :fonts="{
                                    arial: 'Arial',
                                    arial_black: 'Arial Black',
                                    comic_sans: 'Comic Sans MS',
                                    courier_new: 'Courier New',
                                    impact: 'Impact',
                                    lucida_grande: 'Lucida Grande',
                                    times_new_roman: 'Times New Roman',
                                    verdana: 'Verdana'
                                }"
                        >
                                                        
                            <template v-slot:token>
                                <q-btn-dropdown dense no-caps ref="tokenRef" no-wrap unelevated color="white" text-color="primary" label="Token" size="sm">
                                <q-list dense>
                                    <q-item tag="label" clickable @click="addToken('Sabbath', 'editor_token sabbath')">
                                    <q-item-section side>
                                        <q-icon name="fal fa-pray" />
                                    </q-item-section>
                                    <q-item-section>Sabbath</q-item-section>
                                    </q-item>
                                    <q-item tag="label" clickable @click="addToken('Feast', 'editor_token feast')">
                                    <q-item-section side>
                                        <q-icon name="fal fa-info-square" />
                                    </q-item-section>
                                    <q-item-section>Feast</q-item-section>
                                    </q-item>
                                    <q-item tag="label" clickable @click="addToken('Information', 'editor_token information')">
                                    <q-item-section side>
                                        <q-icon name="fal fa-menorah" />
                                    </q-item-section>
                                    <q-item-section>Information</q-item-section>
                                    </q-item>
                                </q-list>
                                </q-btn-dropdown>
                            </template>
                        </q-editor>

                        <div>
                            <q-btn v-if="dayInfo2.dateInfo.isSabbath || dayInfo2.dateInfo.isFeastDay || dayInfo2.dateInfo.isInformation" label="Submit" type="submit" color="primary" v-close-popup/>
                            <q-btn label="Cancel" type="reset" color="primary" flat class="q-ml-sm" />
                            <q-btn v-if="dayInfo2.dateInfo.id > 0" label="Delete" type="reset" @click="onDelete(dayInfo2)" color="primary" flat class="q-ml-sm" />
                        </div>
                    </q-form>                    
                </q-card-section>
                
            </q-card>
        </q-dialog>
    </template>
      
</template>

<script>
import ZadokPlugin from '@/ZadokPlugin';
import moment from 'moment';
    //import { Notify } from 'quasar'
    
    export default {            
        data() {
                return {                                
                    showModal: false,
                    showEditDay: false,
                    currentDate: this.$parent.$parent.currentDate,
                    moonphase: this.$parent.$parent.moonphase,
                    dayInfo2: null,
                    zeroPad: (num, places) => String(num).padStart(places, '0')
                };
            }, 
    name: "ZadokDate",
    //components: { Notify },
    props: ["day"],
    methods: {
            addToken (name, classname) {
                const edit = this.$refs.editorRef
                this.$refs.tokenRef.hide()
                edit.caret.restore()
                edit.runCmd('insertHTML', `&nbsp;<div class="${classname} q-icon row inline items-center" contenteditable="false">&nbsp;<span>${name}</span>&nbsp;</div>&nbsp;`)
                edit.focus()
            },
            formatDate(dateString) {
                const BC = dateString.year <= 0;
                const datestring2 = this.zeroPad(Math.abs(dateString.yearOfEra), 4) + '-' + this.zeroPad(dateString.month, 2) + '-' + this.zeroPad(dateString.day, 2);
                const date = new Date(datestring2);
                const formatstring = ((BC == false) ? 'MMM DD YYYY' : 'MMM DD YYYY BC');
                
                    // Then specify how you want your dates to be formatted
                //return new Intl.DateTimeFormat('default', {dateStyle: 'medium'}).format(date);
                return moment(date).format(formatstring);
            },
            isEquinox(zadocDate) {                
                const gdate = new Date(zadocDate.gregorianDate.year, zadocDate.gregorianDate.month, zadocDate.gregorianDate.day);
                if (gdate.getMonth() == 3 && gdate.getDate() == 20)
                    return true;
                else
                    return false;
            },
            dayOfRemembrance(zadocDate) {                                
                if ((zadocDate.month == 1 || zadocDate.month == 4 || zadocDate.month == 7 || zadocDate.month == 10) && zadocDate.day == 1)
                    return true;
                else
                    return false;
            },
            isFullMoon(zadocDate) {
                const gdate = new Date(zadocDate.gregorianDate.year, zadocDate.gregorianDate.month, zadocDate.gregorianDate.day);
                this.moonphase = this.$parent.$parent.moonphase;
                if (this.moonphase != undefined && this.moonphase != null)
                {
                    for (var i=0; i<this.moonphase.length; i++) {                
                        if (gdate.toLocaleDateString() == this.moonphase[i].date.toLocaleDateString())
                            return true   
                    }
                }
                return false;
            },
            zadocDateCompare(zadocDate, date) {
                const gdate = new Date(zadocDate.gregorianDate.year, zadocDate.gregorianDate.month, zadocDate.gregorianDate.day);
                console.log("current selected day=" + gdate + ' Params:zadocDate=' + gdate.toLocaleDateString() + ',date=' + date.toLocaleDateString());
                const dateYear = date.getFullYear();
                const dateMonth = date.getMonth()+1;
                const dateDay = date.getDate();
                if (zadocDate.gregorianDate.year == dateYear && zadocDate.gregorianDate.month == dateMonth && zadocDate.gregorianDate.day == dateDay)
                    return true;
                else
                    return false;
            },
            showModalPopup(day) {
                this.dayInfo = day;
                this.showModal = true;
            },
            showEditDayPopup(day) {
                this.dayInfo = day;
                this.dayInfo2 = ZadokPlugin.methods.copyObjByVal(day); 
                this.showEditDay = true;
            },
            onReset () {
                this.showEditDay = false;
            },
            async onSubmit (day) {
                day = await this.$parent.$parent.setDate(day);
                this.dayInfo.dateInfo.isSabbath = day.dateInfo.isSabbath;
                this.dayInfo.dateInfo.isFeastDay = day.dateInfo.isFeastDay;
                this.dayInfo.dateInfo.isInformation = day.dateInfo.isInformation;
                this.dayInfo.dateInfo.showInWideBox = day.dateInfo.showInWideBox;
                this.dayInfo.dateInfo.feastDay = day.dateInfo.feastDay;
                this.dayInfo.dateInfo.description = day.dateInfo.description;
                this.dayInfo.dateInfo.id = day.dateInfo.id;
                
            },
            onDelete (day) {                
                this.$parent.$parent.deleteDate(day.dateInfo.id);
                this.dayInfo.dateInfo.isSabbath = false;
                this.dayInfo.dateInfo.isFeastDay = false;
                this.dayInfo.dateInfo.isInformation = false;
                this.dayInfo.dateInfo.showInWideBox = false;
                this.dayInfo.dateInfo.feastDay = "";
                this.dayInfo.dateInfo.description = null;
                this.dayInfo.dateInfo.id = 0;
                this.dayInfo.dateInfo.notes = [];
                this.showEditDay = false;
            }            
        }
    }
</script>

<style>

.editor_token {
  color: white;
  padding: 3px;
}

.editor_token.q-icon {
    border-radius: 3px; 
    width: 6em;
}

.editor_token.sabbath {
  background: orange !important;
}

.editor_token.feast {
  background: #027BE3;  
}

.editor_token.information {
  background: #26A69A;
}

.my-card {
  width: 60% !important;
  max-width: 60% !important
}

.left {
    width: 50% !important;
    text-align: left;
    
}

.redText {
    color: orangered;
}

.blueText {
    color: royalblue;
}

.right {
    width: 50% !important;
    text-align: right;        
}

.full {
    /* display: inline-flex !important; */
    max-width: 100%;
    width: 100% !important;
    text-align: left;
    line-height: 1;
    padding-left: 20px !important;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    scroll-padding: auto;
    flex-grow: 1;
}

.outmonth {    
    font-weight: lighter;
}

.inmonth {
    font-weight: bolder;
}

.lightday {
    font-weight: lighter;
    background-color: beige !important;
}

div.inlineflex{
    display: inline-flex;
}
</style>